import React, { useState } from 'react';
import { Button, Container } from '../../../components';
import CreateOffer from './CreateOffer';
import { IoMdAdd } from 'react-icons/io';
import { RxCross2 } from 'react-icons/rx';
import OfferTable from './OfferTable';

const OfferView = () => {
  const [showCreateOffer, setShowCreateOffer] = useState(false);
  const [offerToEdit, setOfferToEdit] = useState(null);

  const showOffersForm = () => {
    setShowCreateOffer(!showCreateOffer);
    if (showCreateOffer) {
      setOfferToEdit(null); // Clear the offer to edit when closing the form
    }
  };

  const handleEditOffer = (offer) => {
    setOfferToEdit(offer);
    setShowCreateOffer(true);
    window.scrollTo(0, 0);
  };

  return (
    <Container title="Offers">
      <div className="flex lg:flex justify-end mx-5 lg:gap-5 gap-2 mt-3">
        <Button onClick={showOffersForm}>
          <div>{!showCreateOffer ? 'Create Offer' : 'Close Offer'}</div>
          <div>
            {!showCreateOffer ? (
              <IoMdAdd />
            ) : (
              <RxCross2 className="hover:rotate-12" />
            )}
          </div>
        </Button>
      </div>
      <div
        className={`transition-all duration-500 ease-in-out transform ${
          showCreateOffer ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
        }`}
      >
        {showCreateOffer && (
          <CreateOffer
            showOffersForm={showOffersForm}
            offerToEdit={offerToEdit}
          />
        )}
      </div>
      <OfferTable handleEditOffer={handleEditOffer} />
    </Container>
  );
};

export default OfferView;
